import { render, staticRenderFns } from "./DiseaseMainComponent.vue?vue&type=template&id=e89236e6&scoped=true&"
import script from "./DiseaseMainComponent.vue?vue&type=script&lang=ts&"
export * from "./DiseaseMainComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89236e6",
  null
  
)

export default component.exports